import { cleanRedirectUrl } from '@/assets/script/utils/index.js'

import { queryCategoriesId } from '@/graphql/wordpress/query/categories.js'
import {
  queryCategory,
  queryCategoryIntegration,
} from '@/graphql/wordpress/query/category.js'

export default {
  watchQuery: ['prev', 'next'],
  async asyncData({ app, query, error, redirect, route }) {
    try {
      /**
       * 1. Ottengo i parametri della pagina e delle categorie dalla configurazione
       * 2. Ritorno gli id delle categorie per filtrare i vari listing
       * 3. Faccio la query
       */

      // Ritorno la rotta pulita. Da lasciati-ispirare___it a lasciati-ispirare
      const categoryView = route.name.split('___')[0]

      // Ritorno la configurazione della categoria associata a questa view
      const categoryParams = app.$configuration.categories.list.find(
        (category) => category.view === categoryView
      )

      if (!categoryParams) {
        console.error(
          `${categoryView} view doesn't exist in the category configuration`
        )
        return error({
          statusCode: 500,
        })
      }

      // Ritorno la configurazione della/e pagina/e così da ottenere seo, adv etc.
      const pageKey = categoryParams.key
      const pageItem = app.$configuration.pages.list.find(
        (page) => pageKey === page.key
      )

      if (!pageItem) {
        console.error(`[${pageKey}] doesn't exist in the pages configuration`)
        return error({
          statusCode: 500,
        })
      }

      // Ritorno l'ID della categoria
      const [categoryIds] = await app.apolloProvider.defaultClient
        .query({
          query: queryCategoriesId,
          variables: {
            slug: categoryParams.wpSlug,
          },
        })
        .then(({ data }) => data.categories.nodes)

      if (!categoryIds) {
        console.error(
          `${categoryIds} doesn't exist in the category slug configuration`
        )
        return error({
          statusCode: 500,
        })
      }

      // Ritorno i contenuti delle categoria e della pagina associata
      const requestCategory = await app.apolloProvider.defaultClient
        .query({
          query: queryCategory,
          variables: {
            wherePosts: {
              categoryIn: categoryIds.categoryId,
            },
            startCursorPosts: query.prev || null,
            lastPosts: query.prev ? 15 : null,
            endCursorPosts: query.next || null,
            firstPosts: !query.prev ? 15 : null,
            uriPage: pageItem.wpUri,
          },
        })
        .then(({ data }) => data)

      // Redirect
      const matched = requestCategory.redirects.find(
        ({ url }) => url === `/blog${route.path}`
      )
      if (matched) {
        const action = cleanRedirectUrl(matched.action_data)
        redirect(matched.action_code, action)
      }

      if (!requestCategory.pageBy) {
        return error({ statusCode: 404 })
      }

      const page = requestCategory

      return {
        page,
        pageItem,
        categoryParams,
        categoryIds,
      }
    } catch (e) {
      console.error(e)
      // return error({ statusCode: 500 })
    }
  },
  methods: {
    async integrateQuery() {
      try {
        //  Dato che le query sono lente integro i dati del post con una query client side richiamando gli ADV e la descrizione che sono le parti più onerose per la query
        const requestCategoryIntegration = await this.$apollo
          .query({
            query: queryCategoryIntegration,
            variables: {
              wherePosts: {
                categoryIn: this.categoryIds.categoryId,
              },
              startCursorPosts: this.$route.query.prev || null,
              lastPosts: this.$route.query.prev ? 15 : null,
              endCursorPosts: this.$route.query.next || null,
              firstPosts: !this.$route.query.prev ? 15 : null,
              uriPage: this.pageItem.wpUri,
            },
          })
          .then(({ data }) => data)

        // Assegno gli ADV
        /* this.page.pageBy = {
          ...this.page.pageBy,
          advertising: requestCategoryIntegration.pageBy.advertising,
        } */

        this.page = requestCategoryIntegration
      } catch (e) {
        console.error(e)
        // return this.$nuxt.context.error({ statusCode: 500 })
      }
    },
  },
  async mounted() {
    await this.integrateQuery()
  },
  async updated() {
    await this.integrateQuery()
  },
  computed: {
    seo() {
      const seo = this.$generateTags(
        {
          ...this.page.pageBy.seo,
        },
        this.$i18n
      )
      return seo
    },
  },
}
